/* BBQ Rescher – entfernt nur im Grillkurs-Buchungsblock den automatisch gesetzten Doppelpunkt der ersten Variantenüberschrift. */
(() => {
  const cleanBbqrVariantHeading = () => {
    const label = document.querySelector('.Product--bbqrCourse .ProductForm__Variants > .ProductForm__Option:first-child > .ProductForm__Label');
    if (!label) return;

    for (const node of label.childNodes) {
      if (node.nodeType === Node.TEXT_NODE && /:\s*$/.test(node.textContent)) {
        node.textContent = node.textContent.replace(/:\s*$/, '');
        break;
      }
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', cleanBbqrVariantHeading, { once: true });
  } else {
    cleanBbqrVariantHeading();
  }

  document.addEventListener('shopify:section:load', cleanBbqrVariantHeading);
})();
